<template>
  <div>
    <util-tab-title title="Pencatatan Pemakaian Spare Part" class="small" action="/sparepart/list"></util-tab-title>
    <util-chart :chartdata="chart"></util-chart>
    
    <util-add action="/sparepart/add" v-if="group == 'Operator Maintenance' || group == 'Operator Project'"></util-add>
    <util-item-sparepart  :listdata="list"></util-item-sparepart>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import UtilChart from "@/views/pages/Utilities/Components/Util-Chart.vue";
import UtilTabTitle from "@/views/pages/Utilities/Components/Util-Tab-Title.vue";
import UtilItemSparepart from "@/views/pages/Utilities/Components/Util-Item-Sparepart.vue";
import UtilAdd from "@/views/pages/Utilities/Components/Util-Add.vue";
import { api } from "@/api/api.js";
import { UserModule } from "@/store/modules/user";


@Component({
    components: {
      UtilChart,
      UtilTabTitle,
      UtilAdd,
      UtilItemSparepart
    },
})
export default class UtilitiesSparepart extends Vue {
  list = [];
  chart = {series:[],labels:[]};
  group = UserModule.userDetail.accessgroup['name'];
  mounted(){
    api('sparepart_list').then(res => {
      this.list = res.data.data.map(e=>{
        e.date = new Date(e.usage_date);
        return e
      })
    })
    api('sparepart_chart').then(res => {
      let data = res.data
      this.chart.series = data.map(e=>Number(`${e.value}`))
      this.chart.labels = data.map(e=>e.tgl)
    })
  }

}
</script>
